<template>
  <button v-show="value.allowSlidePrev && !value.isBeginning" @click="value.slidePrev()"
    class="swiper-button-custom-prev top-[40%] left-3 absolute z-10">
    <ArrowLeftCircleIcon :class="{
    [cl]: true,
    ['opacity-60 hover:!h-10 hover:!w-10']: !value.isBeginning
  }" />
  </button>
  <button v-show="value.allowSlideNext && !value.isEnd" @click="value.slideNext()"
    class="swiper-button-custom-next top-[40%] right-3 absolute z-10">
    <ArrowRightCircleIcon :class="{
    [cl]: true,
    ['opacity-60 hover:!h-10 hover:!w-10']: !value.isEnd
  }" />
  </button>
</template>
<script lang="ts" setup>
import { useSwiper } from 'swiper/vue'
import { ArrowRightCircleIcon, ArrowLeftCircleIcon } from '@heroicons/vue/24/solid'
const { value } = useSwiper()
const cl = '!h-9 !w-9  text-red-700 transition-all'

defineExpose({
  value
})

</script>
